module.exports = __webpack_public_path__ + "static/media/call-feedback-content-issue-grey.fa09cc19.svg";